// Public API for Facade
// None :)
"use strict";
var type_1 = require("./type");
exports.Type = type_1.Type;
var async_1 = require("./async");
exports.EventEmitter = async_1.EventEmitter;
//# sourceMappingURL=facade.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-metadata/src/facade/facade.js
// module id = 449
// module chunks = 0